import { camelCase } from 'changecase-objects'
import { requestOptions } from '../base'

/**
 * Get the content for a component by its ID.
 *
 * @param {string} componentId - The ID of the component.
 */
export const getComponentById = async (componentId) => {
  const options = requestOptions()
  const response = await fetch(
    `${options.baseUrl}/content/components/${componentId}?t=${options.token}&device_id=${options.deviceId}`,
    {
      method: 'GET',
      headers: {
        ...options.headers,
      },
    },
  )

  const json = await response.json()

  if (!json) {
    return null
  }

  return camelCase(json && json.component)
}

/**
 * Get the content for a page by its name or id.
 */
export const getPageById = async (pageId) => {
  const options = requestOptions()
  const response = await fetch(
    `${options.baseUrl}/content/pages/${pageId}?t=${options.token}&device_id=${options.deviceId}`,
    {
      method: 'GET',
      headers: {
        ...options.headers,
      },
    },
  )

  const json = await response.json()

  if (json.error) {
    throw new Error(json.error)
  }

  return camelCase(json)
}

/**
 * Get the content for the Discover page.
 *
 * The page name was not working, so we are using the page ID instead.
 */
export const discoveryPage = async () => {
  return getPageById(19)
}
